export const setItem = (key, val) => {
  localStorage.setItem(key, val);
};

export const getItem = (key) => {
  return localStorage.getItem(key);
};

export const removeItem = (key) => {
  localStorage.removeItem(key);
};
